(function(){
  "use strict"; "use restrict";
  //GET OR INITIALIZE EHDI
  EHDI = EHDI || Object.create(null);

  /**
   * @desc Asset Storage
   * @member images - Pixi Textures
   * @member cjAssets - String and Sound Files
   */
  EHDI.Assets = {
    images: EHDI.aka.TextureCache,
	fonts: []
  };

  /**
   * @class
   * @desc LoadManager for managing fonts, strings, images and audio
   *       images and fonts are handled by PixiJS while
   *       strings and audio are handled by CreateJS
   *     Loading Priority - createJS loads first then pixiJS.
   *     Load starts by using EHDI.LoadManager.start();
   */
  EHDI.LoadManager = (function(){
    /***************
     *  PRIVATES
     ***************/
    //const
	var _STRINGEXTENSION = ["json", "js", "xml", "txt"];
    var _AUDIOEXTENSION = ["ogg", "mp3", "wav"];
    var _FONTEXTENSION = ["ttf", "woff", "woff2", "otf"];

    //module
    var _public = Object.create(null);
    var _cjAssets, _pixiLoader;

    //manifest for createJS, sounds and strings;
    var _createJSManifest = [];
    var _pixiAssetToBeLoaded = [];
    var _fontToBeParsed = [];
    var _functionOnComplete = null;
    var _onCompleteParam = [];
    var _isLoading = false;
    var _loadProgress = 0;
    var _soundProgress = 0;
    var _totalObjectsToLoad = 0;

    var _createJSManifestToUnload = [];
    var _pixiAssetToBeUnload = [];
    var _totalObjectsToUnload = 0;
    /**
     * loader initalization
     */
    var init = function(){
      _pixiLoader = EHDI.aka.Loader;
      _cjAssets = new createjs.LoadQueue();
      createjs.Sound.alternateExtensions = _AUDIOEXTENSION;

      Object.defineProperty(EHDI.Assets, "cjAssets",{value: _cjAssets,
                                                     enumerable: false });

      _cjAssets.installPlugin(createjs.Sound);
      _cjAssets.addEventListener("progress", cjProgressHandler);
      _cjAssets.addEventListener("complete", cjCompleteHandler);
      _cjAssets.addEventListener("error", cjErrorHandler);

      _pixiLoader.on("progress", pixiProgressHandler);
      _pixiLoader.on("error", pixiErrorHandler);
    }

    /**
     * @param (STRING) id
     * @return the asset from createJS.Loader or pixi.loader
     *         returns null if no object is found
     */
    EHDI.Assets.fetch = function(id){
      var result = _cjAssets.getResult(id);
      if(!result){
        result = EHDI.aka.Loader.resources[id] || null;
      }
      return result;
    }

    /**
     * @desc clears the manifest file
     */
    var clearManifest = function(){
      _pixiAssetToBeLoaded.length = 0;
      _createJSManifest.length = 0;
      _createJSManifestToUnload.length = 0;
      _pixiAssetToBeUnload.length = 0;
    }

    /**
     * @param (Array) urls
     * @param (Array) exts
     */
    var getUrlsBaseOnExtension = function(urls, exts){
      var fileSourcePaths = urls.filter(function (source) {
          if(typeof source !== "string")
              source = source.url;
          var extension = source.split('.').pop();
          return (exts.indexOf(extension) !== -1);
      });
      return fileSourcePaths;
    }

    var fontParser = function(source){
	  var fontData = source.split("/").pop().split(".");
      var fontFamily = fontData[0];
      var fontExt = fontData[1];

	  if(fontExt === "ttf") fontExt = "truetype";
	  if(fontExt === "otf") fontExt = "opentype";
	  if(fontExt === "eot") fontExt = "embedded-opentype";

      var newStyle = document.createElement("style");
      var fontFace = "@font-face {font-family: '" + fontFamily + "'; src: url('" + source + "') format('" + fontExt + "');";
	  newStyle.appendChild(document.createTextNode(fontFace));
      document.body.appendChild(newStyle);
      EHDI.Assets.fonts.push(fontFamily);
    }

    var pixiProgressHandler =  function (loader,resource) {
      _loadProgress = _soundProgress + (loader.progress * (_pixiAssetToBeLoaded.length) /  _totalObjectsToLoad);
    };

    var pixiErrorHandler = function(error, loader,resource){
      console.log("PixiJS Loading Error!");
      console.log(error);
    }

    var pixiCompleteHandler = function(loader,resources){
      clearManifest();
	  _isLoading = false;
      if(_fontToBeParsed.length > 0) {
          _fontToBeParsed.length = 0;
      }
	  if(typeof _functionOnComplete === "function") _functionOnComplete.apply(null, _onCompleteParam);
    }

    var cjProgressHandler = function(e){
      var progress = (e.progress > 1) ? 1 : e.progress;
      _loadProgress = PIXI.VERSION[0] == '5' ? progress * 100 : (progress * (_createJSManifest.length) / _totalObjectsToLoad) * 100;
      _soundProgress = _loadProgress;
    }

    var cjCompleteHandler = function(e){
      if(_pixiAssetToBeLoaded.length <= 0){
        pixiCompleteHandler();
        return;
      }
      _pixiLoader.add(_pixiAssetToBeLoaded).load(pixiCompleteHandler);
    }

    var cjErrorHandler = function(e){
      console.log("CreateJS Loading Error");
      console.log(e);
    }

    /**
     * @param (jsonmanager) -jsonmanager component
     * @param (id) - config file id
     */
    var configHandler = function(jsonmanager, id, callback){
      var configJSON, localeConfig, locid, localeUrl, lang, onDone;
      var ext = ".json";
      var _loader;
      var _fontsToLoad, _stringToLoad;
      configJSON = _cjAssets.getResult(id);
      localeConfig = configJSON.locale;
      localeUrl = localeConfig.url;
      lang = (typeof localeConfig.lang !== "undefined") ? localeConfig.lang : "en";
      locid = localeConfig.id + lang;

      if(typeof localeConfig.font[lang] === "undefined"){
        _fontsToLoad = localeConfig.font["default"];
      }else{
        _fontsToLoad = localeConfig.font[lang];
      }

      _stringToLoad = [localeUrl+locid+ext];

      onDone = function(){
        jsonmanager.setConfigData(configJSON);
        jsonmanager.setLocaleData(_cjAssets.getResult(locid));
        if(typeof callback === "function") callback();
      }
      _public.queueStrings(_stringToLoad);
      _public.queueFonts(_fontsToLoad);
      _public.start(onDone);
    }

    var startUnload = function(){
      var asset, item;
      while(_createJSManifestToUnload.length > 0){
        item = _createJSManifestToUnload.pop();
        asset =  _cjAssets.getItem(item);
        _cjAssets.remove(asset.id);
        if(asset.type === "sound"){
          createjs.Sound.removeSound(asset.id);
        }
      }

      while(_pixiAssetToBeUnload.length > 0){
        item = _pixiAssetToBeUnload.pop();
        asset = EHDI.Assets.images[item];
        asset.destroy(true);
      }

      if(_createJSManifest.length > 0){
        _cjAssets.loadManifest(_createJSManifest);
      }else{
        cjCompleteHandler();
      }
    }

    init();

    /**************
     *  PUBLIC
     *************/
    /**
     * @param (ARRAY<STRING>) url paths of the strings to be loaded
     * @desc add string url to queue
     */
    _public.queueStrings = function(urls){
      var manifest = [];
      var url, id;
      while(urls.length > 0){
        url = urls.pop();
        //id = url.split("/").pop(); //has .fileType
        id = url.split("/").pop().split(".")[0];

        manifest.push({
          id: id, src: url
        })
      };

      _createJSManifest = _createJSManifest.concat(manifest);
    }

    /**
     * @param (ARRAY<STRING>) url paths of the fonts to be loaded
     * @desc add font url to queue
     */
    _public.queueFonts = function(urls){
      //var fontsToLoad = []
      var url, id;
      while(urls.length > 0){
        url = urls.pop();
        id = url.split("/").pop().split(".")[0];
        _fontToBeParsed.push(fontParser(url));
        /*fontsToLoad.push({
          name: id, url: url
        })*/
      };

      //_pixiAssetToBeLoaded = _pixiAssetToBeLoaded.concat(fontsToLoad);
    }

    /**
     * @param (ARRAY<STRING>) url paths of the fonts to be loaded
     * @desc add audio url to queue
     */
    _public.queueAudios = function(urls){
      var manifest = []
      var url, id;
      while(urls.length > 0){
        url = urls.pop();
        if(typeof url !== "string") {
            id = url.id;
            url = url.url;
        } else {

            id = url.split("/").pop().split(".")[0];
        }
        manifest.push({
          id: id, src: url
        })
      };
      _createJSManifest = _createJSManifest.concat(manifest);
    }

    /**
     * @param (ARRAY<STRING>) url paths of the images to be loaded
     * @desc add image url to queue, can also use to parse atlas
     */
    _public.queueImages = function(urls){
      var imagesToBeLoaded = [];
      var url, id;
      while(urls.length > 0){
        url = urls.pop();
        if(typeof url !== "string") {
            id = url.id;
            url = url.url;
        } else {
            id = url.split("/").pop().split(".")[0];
        }
        imagesToBeLoaded.push({
          name: id, url: url
        })
      };

      _pixiAssetToBeLoaded = _pixiAssetToBeLoaded.concat(imagesToBeLoaded);
    }

    /**
     * @param (ARRAY<STRING>) url paths of the assets to be loaded
     * @desc loads all assets.
     */
    _public.queueAssets = function(urls){
      var filterUrls = function(main, filt){
        main = main.filter(function (source) {
            return filt.indexOf(source) < 0;
        });
        return main;
      }

      var fontsToLoad = getUrlsBaseOnExtension(urls, _FONTEXTENSION);
      var audiosToLoad = getUrlsBaseOnExtension(urls, _AUDIOEXTENSION);
	  var stringsToLoad = getUrlsBaseOnExtension(urls, _STRINGEXTENSION);
      var imgFileToLoad = filterUrls(urls, fontsToLoad);
	  imgFileToLoad = filterUrls(imgFileToLoad, stringsToLoad);
      imgFileToLoad = filterUrls(imgFileToLoad, audiosToLoad);


      _public.queueFonts(fontsToLoad);
      _public.queueAudios(audiosToLoad);
	  _public.queueStrings(stringsToLoad);
      _public.queueImages(imgFileToLoad);
    }

    /**
     * @param (STRING) url path of the config file
     * @param (OBJECT) JSONManager component
     * @param (FUNCTION) callback
     * @desc loads config file and its dependencies
     */
    _public.loadConfig = function(url, jsonmanager, callback){
      if(typeof url !== "string") throw new Error("Invalid URL");
      if(typeof jsonmanager === "undefined") throw new Error("needs JSONManager component");
      if(_isLoading) throw new Error("Load manager is currently running");
      var id = url.split("/").pop().split(".")[0];
      clearManifest();
      _public.queueStrings([url]);
      _public.start(configHandler, [jsonmanager, id, callback]);
    }

	/**
	 * @return gets the progress of the load manager.
	 */
    _public.getProgress = function(){
      return _loadProgress;
    }

    /**
     * @param (function) callback - the callback function when loading ends
     * @param (ARRAY) params - the callback parameters
     * @desc starts loading and storing files
     */
    _public.start = function(callback, params){
      if(_isLoading) throw new Error("EHDI Load manager is currently running");
      _functionOnComplete = callback;
      _onCompleteParam = params;
      _isLoading = true;
      _loadProgress = 0;
	  _soundProgress = 0;
      _totalObjectsToLoad = _createJSManifest.length + _pixiAssetToBeLoaded.length;
      _totalObjectsToUnload = _createJSManifestToUnload.length + _pixiAssetToBeUnload.length;
	  _pixiLoader.reset();
	  startUnload();
    }

    /**
     * @param (ARRAY<STRING>) url paths of the images to be loaded
     * @desc add urls to unload queue
     */
    _public.unloadAssets = function(urls){
      var filterUrls = function(main, filt){
        main = main.filter(function (source) {
            return filt.indexOf(source) < 0;
        });
        return main;
      }

      var fontsToUnload = getUrlsBaseOnExtension(urls, _FONTEXTENSION);
      var audiosToUnload = getUrlsBaseOnExtension(urls, _AUDIOEXTENSION);
	  var stringsToUnload = getUrlsBaseOnExtension(urls, _STRINGEXTENSION);
      var imgFileToUnload = filterUrls(urls, audiosToUnload);
	  imgFileToUnload = filterUrls(imgFileToUnload, stringsToUnload);
      imgFileToUnload = filterUrls(imgFileToUnload, fontsToUnload);

      _createJSManifestToUnload = _createJSManifestToUnload.concat(audiosToUnload);
	  _createJSManifestToUnload = _createJSManifestToUnload.concat(stringsToUnload);
      _pixiAssetToBeUnload = _pixiAssetToBeUnload.concat(imgFileToUnload);
    }

    return _public;

  }());

}());
